import { Typography } from 'shared/ui'

import { ModalInfoBlock } from 'shared/ui/Modal/ui/ModalInfoBlock/ModalInfoBlock'
import { type IModalInfoRowProps } from 'shared/ui/Modal/ui/ModalInfoRow/ModalInfoRow'
import styles from './styles.module.scss'

type IModalInfoBlockWithTitleProps = {
  title: string
  lines: IModalInfoRowProps[]
}

export const ModalInfoBlockWithTitle = ({ title, lines }: IModalInfoBlockWithTitleProps) => {
  return (
    <div>
      <Typography
        ariaLabel='ModalInfoBlockWithTitle'
        variant='body-rg-medium'
        className={styles.title}
      >
        {title}
      </Typography>
      <ModalInfoBlock lines={lines} />
    </div>
  )
}
